import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './assets/styles/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-pro-sidebar/dist/css/styles.css";
import AppRoutes from './routes/AppRoutes';
import { Provider } from 'react-redux';
import { store } from './store';
import { ActiveProvider } from './pages/Applicants/ActiveProvider';



const App = () => {
  return (
    <AppRoutes />
  )
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ActiveProvider>
        <App />
      </ActiveProvider>
    </BrowserRouter>
  </Provider>
);


// import React from 'react';
// import ReactDOM from 'react-dom';
// import { BrowserRouter } from "react-router-dom";
// import './assets/styles/index.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import "react-pro-sidebar/dist/css/styles.css";
// import AppRoutes from './routes/AppRoutes';
// import { Provider } from 'react-redux';
// import { store } from './store';
// import { ActiveProvider } from './pages/Applicants/ActiveProvider';


// const App = () => {
//   return (
//     <AppRoutes />
//   );
// };

// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <BrowserRouter>
//         <ActiveProvider>
//           <App />
//         </ActiveProvider>
//       </BrowserRouter>
//     </Provider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))

